import { TelegramIcon } from "../../assets/img/TelegramIcon";
import {
  JoinCommunityMain,
  JoinCommunityWrapper,
} from "./JoinCommunity.styled";

export const JoinCommunity = () => {
  return (
    <JoinCommunityWrapper>
      <div className='container'>
        <JoinCommunityMain>
          <h3>Join our community</h3>
          <span>
            TonTake is the ability to support digital artists and to decorate
            your personal virtual room with NFTs.
          </span>
          <button>Telegram {TelegramIcon()}</button>
        </JoinCommunityMain>
      </div>
    </JoinCommunityWrapper>
  );
};
